import { RightCircleFilled } from '@ant-design/icons';
import styled from 'styled-components';

export const FieldDetailsBtnIcon = styled(RightCircleFilled)`
  font-size: 24px;
  padding: 5px;
  margin-top: -6px;
`;
